import * as React from 'react';

function CloseFilterButton( { onClick, className } ) {
    const defaultClass = 'close_button';
    const combinedClassName = className ? `${defaultClass} ${className}` : defaultClass;
    return (
        <div className={combinedClassName} onClick={onClick}></div>
    )
}

export default CloseFilterButton;